// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PhysicalQuantity } from "./PhysicalQuantity";
import {
  PhysicalQuantityFromJSON,
  PhysicalQuantityFromJSONTyped,
  PhysicalQuantityToJSON,
  PhysicalQuantityToJSONTyped,
} from "./PhysicalQuantity";

/**
 *
 * @export
 * @interface RasterLayerProperties
 */
export interface RasterLayerProperties {
  /**
   *
   */
  styleId: string;
  /**
   *
   */
  type?: RasterLayerPropertiesTypeEnum;
  /**
   *
   */
  physicalQuantity?: PhysicalQuantity;
  /**
   *
   */
  minMax?: Array<any> | null;
}

/**
 * @export
 */
export const RasterLayerPropertiesTypeEnum = {
  Raster: "raster",
} as const;
export type RasterLayerPropertiesTypeEnum =
  (typeof RasterLayerPropertiesTypeEnum)[keyof typeof RasterLayerPropertiesTypeEnum];

/**
 * Check if a given object implements the RasterLayerProperties interface.
 */
export function instanceOfRasterLayerProperties(value: object): value is RasterLayerProperties {
  if (
    (!("styleId" in (value as Record<string, any>)) &&
      !("style_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["styleId"] === undefined &&
      (value as Record<string, any>)["style_id"] === undefined)
  )
    return false;
  return true;
}

export function RasterLayerPropertiesFromJSON(json: any): RasterLayerProperties {
  return RasterLayerPropertiesFromJSONTyped(json, false);
}

export function RasterLayerPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterLayerProperties {
  if (json == null) {
    return json;
  }
  return {
    styleId: json["style_id"],
    type: json["type"] == null ? undefined : json["type"],
    physicalQuantity:
      json["physical_quantity"] == null
        ? undefined
        : PhysicalQuantityFromJSON(json["physical_quantity"]),
    minMax:
      json["min_max"] === undefined ? undefined : json["min_max"] === null ? null : json["min_max"],
  };
}

export function RasterLayerPropertiesToJSON(json: any): RasterLayerProperties {
  return RasterLayerPropertiesToJSONTyped(json, false);
}

export function RasterLayerPropertiesToJSONTyped(
  value?: RasterLayerProperties | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    style_id: value["styleId"],
    type: value["type"],
    physical_quantity: PhysicalQuantityToJSON(value["physicalQuantity"]),
    min_max: value["minMax"],
  };
}
